<template>
  <div class="awards" :class="platform">
    <div v-if="awards.main" class="amount">
      <span v-if="isStepBonus" class="amount-to">
        {{ t('bonuses.toAmount') }}
      </span>
      <div class="amount-value" data-t="main-amount">
        <StIcon v-if="awards.main.icon" :name="awards.main.icon" :size="24" />
        {{ awards.main.amount }}
      </div>
    </div>
    <p v-if="awards.others.length" class="sub-bonuses" data-t="sub-bonuses">
      <template v-for="(subBonus, index) in awards.others" :key="index">
        <span> + </span>
        <span v-if="isStepBonus">{{ t('bonuses.toAmount') }}</span>
        <span>{{ subBonus?.amount }}</span>
        <StIcon
          v-if="subBonus?.icon"
          :name="subBonus.icon"
          :size="16"
          class="icon"
        />
        <span v-if="subBonus?.text" class="sub-bonus-text">
          {{ subBonus.text }}
        </span>
      </template>
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  awards: {
    main: {
      icon: string | null
      amount: string
      amountWithCurrency?: string
      text: string
    }
    others: {
      icon: string | null
      amount: string
      amountWithCurrency?: string
      text: string
    }[]
  }
  isStepBonus?: boolean
}

const { awards, isStepBonus } = defineProps<Props>()

const { t } = useI18n()

const { platform } = usePlatform()
</script>

<style scoped>
.amount {
  display: flex;
  gap: var(--spacing-025);
  align-items: center;

  font: var(--desktop-text-2xl-semibold);
  color: var(--text-primary);

  .amount-to {
    font: var(--desktop-text-xl-semibold);
  }
}

.sub-bonuses {
  overflow: hidden;

  max-width: 100%;
  margin: 0;

  font: var(--desktop-text-md-medium);
  color: var(--text-primary);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sub-bonus-text {
  margin-left: var(--spacing-025);
}

.icon {
  min-width: 16px;
  margin: calc(var(--spacing-025) * -1) var(--spacing-025);
}

.awards {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  padding-top: var(--spacing-025);

  &.mobile {
    flex-direction: row;
    padding-top: 0;

    .amount {
      font: var(--mobile-title-2-semibold);

      .amount-to {
        font: var(--mobile-title-2-semibold);
      }
    }

    .sub-bonuses {
      font: var(--mobile-title-2-semibold);
    }
  }
}
</style>
